import ProxyBase from '../../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getFollowSettings(params) {
    return this.get('Alert/Settings/FollowSetting', params)
  }

  saveFollowSettings(params) {
    return this.post('Alert/Settings/FollowSettingSave', params)
  }

  getAlertSettings(params) {
    return this.get('Alert/Settings/UserSettings', params)
  }
}

export default new Proxy()
